import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget } from '@eforall/dashboard';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { PersonExplorerService } from '../person-explorer.service';
import { getSetup } from "./grid/get-setup";


@Component({
	selector: 'person-engagements-part',
	standalone: true,
	imports: [
		TabStripModule,
		GridContentWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './person-engagements.part.html'
})

export class PersonEngagementsPart {

	#util = inject(UtilityService);
	personExplorer = inject(PersonExplorerService);
	public setup = getSetup(this.#util);

	public engagements = computed(() => this.personExplorer.person.value()?.engagements ?? []);
}